import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

import TeamMember from '../components/team_member';
import * as photos from '../components/team_member/photos';

export default class Members extends React.Component {
  render() {
    return (
      <Row>
        <Col md={12} style={{ display: 'flex', flexWrap: 'wrap' }}>
          <TeamMember
            email="sirlova@stuzak.cz"
            name="Tereza Šírlová"
            photo={photos.sirlova}
            position="Předsedkyně spolku"
          />
          <TeamMember
            email="dvorakova@stuzak.cz"
            name="Michéle Dvořáková"
            photo={photos.dvorakova}
            position="Členka správní rady"
          />
          <TeamMember
            email="blaho@stuzak.cz"
            name="Jakub Blaho"
            photo={photos.blaho}
            position="Člen správní rady"
          />
          <TeamMember
            email="kvaltynova@stuzak.cz"
            name="Zuzana Kvaltýnová"
            photo={photos.kvaltynova}
            position="Členka správní rady"
          />
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/contactpage/members.jsx